import Http from './http'

export default {
  index(filter) {
    return Http.get(`/approvals`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  show(id) {
    return Http.get(`/approvals/${id}`);
  },

  create(approval) {
    return Http.post(`/approvals`, {approval: {...approval}});
  },

  update(approval) {
    return Http.put(`/approvals/${approval.id}`, {approval: {...approval}});
  },


  indexApprovalGroups(filter) {
    return Http.get('/approval_groups', {
      params: {
        ...filter
      }
    })
  },

  createApprovalGroup(approval_group) {
    return Http.post('/approval_groups', {
      approval_group: {
        approvals_attributes: [...approval_group.approvals],
        ...approval_group
      }
    })
  },
  showApprovalGroup(approval_group_id) {
    return Http.get(`/approval_groups/${approval_group_id}`);
  },
  updateApprovalGroup(approval_group) {
    return Http.put(`/approval_groups/${approval_group.id}`, {
      approval_group: {
        approvals_attributes: [...approval_group.approvals],
        ...approval_group
      }
    })
  },
  deleteApprovalGroup(approval_group_id) {
    return Http.delete(`/approval_groups/${approval_group_id}`);
  }
}
